
import { RevBreadcrumb } from '@ds/components/Breadcrumb'
import isEmpty from 'lodash/isEmpty'

import { ROUTES } from '@router'

import translations from './Breadcrumb.translations'

export default {
  components: {
    RevBreadcrumb,
  },

  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
    modelsNames: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    breadcrumbs() {
      const homepageRoute = {
        slug: { name: ROUTES.HOME },
        title: this.$t(translations.home),
      }
      const categoryRoute = {
        slug: {
          name: ROUTES.MODELS_COMPARISON.CATEGORY,
          params: { category: this.category.name },
        },
        title: this.category.label,
      }
      const comparisonResultsRoute = {
        slug: {
          name: ROUTES.MODELS_COMPARISON.COMPARISON_RESULTS,
          params: {
            productA: this.$route.params.productA,
            productB: this.$route.params.productB,
          },
        },
        title: this.$t(translations.modelAVsModelB, {
          modelA: this.modelsNames[0],
          modelB: this.modelsNames[1],
        }),
      }
      const modelsComparisonHomeRoute = {
        slug: {
          name: ROUTES.MODELS_COMPARISON.HOME,
        },
        title: this.$t(translations.compare),
      }

      const isCategoryPage = !isEmpty(this.$route.params.category)
      const isComparisonResultsPage =
        !isEmpty(this.$route.params.productA) &&
        !isEmpty(this.$route.params.productB)

      const homeRoutes = [homepageRoute, modelsComparisonHomeRoute]

      if (isCategoryPage) {
        return [...homeRoutes, categoryRoute]
      }

      if (isComparisonResultsPage) {
        return [...homeRoutes, categoryRoute, comparisonResultsRoute]
      }

      return [...homeRoutes]
    },
  },
}
